<app-pagetitle title="Assinatura de documentos" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>


<div class="row">
    <div class="col-xl-12">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Assinatura de Documentos</h4>
                <p class="card-title-desc">Inicie o processo de assinatura digital de documentos
                </p>
            </div>

            <div class="card-body">
                <div class="row">
                    <div class="col-xl-3">
                        <ul ngbNav #nav1="ngbNav" [activeId]="abaEtapa" class="flex-column nav-pills">
                            @if(statusDocumento.statusDocumentoAssinatura == 1 )
                            {
                            <li [ngbNavItem]="0" class="nav flex-column nav-pills pricing-tab-box">
                                <app-card-titulo-etapa [tipoSucesso]="false" [titulo]="'Trabalhando'"
                                    [descricao]="'Processando documento'"></app-card-titulo-etapa>

                                <ng-template ngbNavContent>
                                    <div class="tab-pane fade show active" id="v-price-one" role="tabpanel"
                                        aria-labelledby="v-pills-tab-one">
                                        <div class="text-center">
                                            <app-documento-enviado [documento]=statusDocumento></app-documento-enviado>
                                        </div>
                                    </div>
                                </ng-template>
                            </li>
                            }
                            <li [disabled]="desabilitarEtapaDocumento" [ngbNavItem]="1"
                                class="col-12 nav flex-column nav-pills pricing-tab-box">

                                <app-card-titulo-etapa [tipoSucesso]="etapaDocumento" [titulo]="'Documento'"
                                    [descricao]="'Envio do contrato'"></app-card-titulo-etapa>

                                <ng-template ngbNavContent>
                                    <div class="col-xl-12 ps-4 pe-4">
                                        <div class="mt-4 ps-4 pe-4 justify-content-center d-flex ab-pane fade show active"
                                            id="v-price-one" role="tabpanel" aria-labelledby="v-pills-tab-one">

                                            @if(etapaDocumento){
                                            <app-card-etapa-concluida></app-card-etapa-concluida>
                                            }@else {
                                            <div class="col-12">
                                                <app-upload-documento></app-upload-documento>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </ng-template>
                            </li>
                            <li [disabled]="desabilitarEtapaAssinatura" [ngbNavItem]="2"
                                class="nav flex-column nav-pills pricing-tab-box">

                                <app-card-titulo-etapa [tipoSucesso]="etapaAssinatura" [titulo]="'Signatário'"
                                    [descricao]="'Cadastro dos signatários'"></app-card-titulo-etapa>

                                <ng-template ngbNavContent>
                                    <div class="tab-pane fade show active" id="v-price-one" role="tabpanel"
                                        aria-labelledby="v-pills-tab-one">
                                        <div class="text-center">

                                            @if(!etapaAssinatura){
                                            <app-signatario
                                                [documentoJaEnviadoParaAssinatura]=statusDocumento></app-signatario>
                                            }@else{
                                            <app-card-etapa-concluida></app-card-etapa-concluida>
                                            }

                                        </div>
                                    </div>
                                </ng-template>
                            </li>
                            <li [disabled]="desabilitarEtapaEmail" [ngbNavItem]="3"
                                class="nav flex-column nav-pills pricing-tab-box">

                                <app-card-titulo-etapa [tipoSucesso]="etapaEmail" [titulo]="'E-mail'"
                                    [descricao]="'Envio dos e-mails para assinaturas'"></app-card-titulo-etapa>
                                <ng-template ngbNavContent>
                                    <div class="tab-pane fade show active" id="v-price-one" role="tabpanel"
                                        aria-labelledby="v-pills-tab-one">
                                        <div class="text-center">

                                            @if(!etapaEmail){
                                            <div class="justify-content-center">
                                                <div class="row">
                                                    <div class="col-lg-12">
                                                        <div class="card">
                                                            <div class="card-header">
                                                                <h4 class="card-title">Envio de e-mail para assinaturas
                                                                </h4>
                                                            </div>
                                                            <div class="card-body">

                                                                <div class="mt-4">

                                                                    <p>Realize o envio dos e-mails solicitando as
                                                                        assinatura.</p>
                                                                </div>
                                                                <div class="d-flex justify-content-center">

                                                                    @if(isLoading){
                                                                    <button type="button"
                                                                        class="btn btn-light waves-effect">
                                                                        <i
                                                                            class="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                                                        Trabalhando
                                                                    </button>
                                                                    }@else {

                                                                    <button [disabled]="false"
                                                                        (click)="enviarArquivoAssinatura()"
                                                                        type="submit"
                                                                        class="btn btn-info waves-effect waves-light d-flex">
                                                                        <i
                                                                            class=" mt-1  bx bx-mail-send d-block font-size-16 me-3"></i>
                                                                        Enviar E-mails
                                                                    </button>
                                                                    }
                                                                </div>


                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            }@else {
                                            <div class="row justify-content-center">
                                                <div class="col-4">

                                                    <div class="">
                                                        <div class="alert alert-info alert-dismissible fade show px-4 mb-0 text-center"
                                                            role="alert">
                                                            <i
                                                                class="mdi mdi-alert-circle-outline d-block display-4 mt-2 mb-3 text-info"></i>
                                                            <h5 class="text-info">Estapa Concluída!</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </ng-template>
                            </li>
                        </ul>
                    </div>
                    <div class="col-xl-9">
                        <div [ngbNavOutlet]="nav1"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>